import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateBranchEntity } from '../../domain/entities/CreateUpdateBranchEntity'
import { BranchPeriodModel } from './BranchPeriodModel'
import type { BranchShiftDayTimeSlotEntity } from '../../domain/entities/BranchShiftDayTimeSlotEntity'

export class CreateUpdateBranchModel extends CreateUpdateBranchEntity {
  brandId!: number
  serviceId!: number
  categoriesId?: Array<number>
  userIds!: Array<string>
  branchTagIds?: Array<number>
  translations = []
  channelId!: number
  saleManId?: number
  branchDeliverySystemIds?: Array<number> | null
  branchMinimumCartSystemId?: number | null
  relatedChannelIds?: Array<number> | null
  disabled = false
  declare allowOperatorItemPriceEdit?: boolean

  constructor(dataDto: CreateUpdateBranchEntity) {
    super()
    const shifts = dataDto.branchShiftDays?.filter(
      (shift) => shift.periods && shift.periods?.length > 0
    )
    mapEntityProperties<CreateUpdateBranchModel>(this, dataDto, {
      exclude: [
        'brand',
        'categories',
        'service',
        'users',
        'channel',
        'saleMan',
        'branchTags',
        'branchDeliverySystems',
        'relatedChannels',
        'minimumCartSystem'
      ],
      map: {
        autoAcceptMeals: dataDto.autoAcceptMeals ?? false,
        brandId: dataDto.brand?.id,
        brand: dataDto.newBrand
          ? {
              coverImage: dataDto.newBrand.coverImage,
              profileImage: dataDto.newBrand.profileImage,
              translations: dataDto.translations?.map((translation) => {
                return {
                  name: translation.name,
                  language: translation.language
                }
              })
            }
          : undefined,
        serviceId: dataDto.service?.id,
        categoriesId: dataDto.categories?.map((category) => category.id),
        userIds: dataDto.users?.map((user) => user.id),
        branchTagIds: dataDto.branchTags?.map((branchTag) => branchTag.id),
        channelId: dataDto.channel?.id,
        manualStatusExpiresAt: undefined,
        saleManId: dataDto.saleMan?.id,
        branchDeliverySystemIds: dataDto.branchDeliverySystems?.map(
          (branchDeliverySystem) => branchDeliverySystem.id
        ),
        branchMinimumCartSystemId: dataDto.minimumCartSystem?.id ?? null,
        relatedChannelIds: dataDto.relatedChannels?.map((channel) => channel.id),
        branchShiftDays: shifts?.map((shift) => ({
          dayOfWeek: shift.dayOfWeek,
          periods: shift.periods?.map((period: BranchShiftDayTimeSlotEntity) => {
            if (!period.startTimeDayOfWeek) {
              period.startTimeDayOfWeek = shift.dayOfWeek
            }
            if (!period.endTimeDayOfWeek) {
              period.endTimeDayOfWeek = shift.dayOfWeek
            }
            return new BranchPeriodModel(period)
          }),
          overallShiftStatus: shift.overallShiftStatus
        }))
      }
    })
  }
}
